"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var o=require("styled-components");const i={sm:"481px"},t=(t,r)=>o.css`
        @media screen and (min-width: ${i[t]}) {
            ${r}
        }
    `,r=(i="16px")=>o.css`
    > :not([hidden]) ~ :not([hidden]) {
        margin-top: ${i};
    }
`,e=t("sm",o.css`
        &.affix-right {
            .col-1 {
                margin-left: 0;
                margin-right: 40px;
            }
            .col-2 {
                margin-left: auto;
            }
        }
        .col-1 {
            margin-left: 40px;
            margin-top: 20px;
            width: calc(100% - 40px);
        }
        .col-2 {
            grid-row-start: 1;
        }
        .details-pane {
            border-radius: ${12}px;
            margin-top: 0;
            padding: 32px;
        }
        .details-pane-secondary--inner {
            height: auto;
            padding-top: unset;
            > :first-child {
                margin-top: 0;
            }
        }
    `),a=o.css`
    ${i=>{return t=null==i?void 0:i.theme,o.css`
        --component-accent-color-base: var(
            --component-accent-color,
            var(--dx-colors-primary, ${null===(e=null===(r=null==t?void 0:t.colors)||void 0===r?void 0:r.primary)||void 0===e?void 0:e.default})
        );
        --component-font-family-base: var(
            --component-font-family,
            var(--dx-fonts-primary, '${null===(n=null===(a=null==t?void 0:t.fonts)||void 0===a?void 0:a.primary)||void 0===n?void 0:n.fontFamily}')
        );
    `;var t,r,e,a,n}}
    width: 100%;
    position: relative;
    max-width: 1246px;
    display: grid;
    grid-template-columns: 1fr;
    color: #25292d;
    font-family: var(--component-font-family-base);
    h2,
    p {
        margin: 0;
    }
    h2 {
        font-size: 25px;
    }
    .col-1 {
        grid-row-start: 1;
        grid-column-start: 1;
    }
    .col-2 {
        grid-row-start: 2;
        grid-column-start: 1;
        margin-bottom: 20px;
        pointer-events: none;
    }

    .details-pane {
        pointer-events: initial;
        background-color: white;
        border-radius: 0 0 ${12}px ${12}px;
        padding: 20px;
        box-shadow: 0px 40px 40px rgba(0, 0, 0, 0.1);
        max-width: 375px;
        margin-top: -${24}px;
        position: relative;
        height: auto;
        ${r("20px")}
    }

    .details-pane-secondary {
        background-color: #f7f9fb;
        border-radius: 4px;
        padding: 16px;
    }
    .details-pane-secondary--inner {
        transition: height 250ms ease-out;
        height: var(--splh-details-pane-height, 0);
        overflow: hidden;
        ${r("20px")}
        > :first-child {
            margin-top: 20px;
        }
    }

    ${e}
`;exports.addChildVerticalSpace=r,exports.default=a,exports.responsive=t,exports.styles=a;
//# sourceMappingURL=styles.js.map
